import { usePrompt } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import VehicleSelect from '@/components/vehicle-select'
import { Module } from '@/modules/companies/consts'
import { AllVehicleExpirationDates } from '@/modules/vehicles/fleet/components/AllVehicleExpirationDates'
import React, { useState } from 'react'
import styled from 'styled-components'
import { useVehicleExpirationTypeMutations } from '../../../vehicles/fleet/mutations.hooks'
import type { VehicleExpirationTypeForm } from '../components'
import {
  OldAddButton,
  Header,
  InfoBox,
  OldSection,
  SettingsWrapper,
} from '../components'
import { AddVehicleExpirationTypeModal } from '../components/AddVehicleExpirationTypeModal'
import { ModuleResponsibleUsers } from '../components/ModuleResponsibleUsers'

const StyledHeader = styled(Header)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
`

const StyledAddCategoryNameBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

interface VehicleFleetSettingsProps {}

export const VehicleFleetSettings: React.FC<VehicleFleetSettingsProps> = () => {
  const translations = useTranslate({
    info: 'settings.info.vehicles',
    vehicleExpirations: 'vehicles.expiration-dates',
    documentsAndExpirations: 'common.documents-and-expirations',
    type: 'form.type-material',
    createForm: 'common.create-form',
    create: 'common.create-alt',
    editForm: 'form.edit-form',
    close: 'common.close',
    addExpirationType: 'settings.add-vehicle-expiration-type',
  })
  const [vehicleId, setVehicleId] = useState<string | null>(null)

  const addPrompt = usePrompt()
  const { createVehicleExpirationType } = useVehicleExpirationTypeMutations()

  const handleCreate = async () => {
    const { data } = await addPrompt<VehicleExpirationTypeForm | null>(
      resolve => <AddVehicleExpirationTypeModal onSubmit={resolve} />
    )

    if (!data) return

    await createVehicleExpirationType({
      variables: {
        input: {
          name: data.categoryName,
        },
      },
    })
  }

  return (
    <SettingsWrapper grid={{ flow: 'row' }}>
      <InfoBox>
        <p>{translations.info}</p>
      </InfoBox>

      <ModuleResponsibleUsers module={Module.VEHICLES} />

      <StyledAddCategoryNameBlock>
        <OldAddButton
          addText={translations.addExpirationType}
          adding={false}
          onClick={handleCreate}
        />
      </StyledAddCategoryNameBlock>

      <OldSection>
        <StyledHeader>
          <h2>{translations.documentsAndExpirations}</h2>
          <VehicleSelect
            mode="single"
            value={vehicleId ?? ''}
            clearable
            className="w-full max-w-[400px]"
            onChange={vehicle => setVehicleId(vehicle?.id ?? null)}
          />
        </StyledHeader>
        <AllVehicleExpirationDates vehicleId={vehicleId} />
      </OldSection>
    </SettingsWrapper>
  )
}
